import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';

import { DomainID } from '../../types/Domain';
import { PoolAssignmentDropdown, PoolAssignmentDropdownProps } from './PoolAssignmentDropdown';

export type MoveDomainDialogBodyInputProps = Readonly<{
  domainName: DomainID;
}>;

export type MoveDomainDialogBodyProps =  PoolAssignmentDropdownProps & MoveDomainDialogBodyInputProps;

export function MoveDomainDialogBody(props: MoveDomainDialogBodyProps) {
    return (
        <>
            <span className={lineClass}>
              {Messages.dataConnectSiteSettingsMoveDomainDescription()}
            </span>
            <span className={lineClass}>
              {Messages.dataConnectSiteSettingsDomain()}
            </span>
            <span className={lineClass}>
              {props.domainName}
            </span>
            <PoolAssignmentDropdown {...props} />
        </>
    );
}

const lineClass = style({ marginTop: 10, display: 'block' });
